/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import {
	ISchemaStringTranslateModel,
	SCHEMA_VALUE_TYPE,
	TGenericModelNode
} from "@adapptio/lib-blueprint";
import { IInspectorControls, TInspectorControlComponent } from "../InspectorTypes";
import { useBlueprintModel } from "../../../hooks/useBlueprintModel";
import { InvalidModelNode } from "../InvalidModelNode";
import { FieldInlineLabel } from "../../Fields/FieldInlineLabel";

export const ControlStringTranslate_Primary: TInspectorControlComponent<ISchemaStringTranslateModel> = ({
	model: _model
}) => {
	const { model, validationErrors } = useBlueprintModel(_model, "stringTranslate");

	if (!model) {
		return <InvalidModelNode model={_model} />;
	}

	const value = model.value.type === SCHEMA_VALUE_TYPE.CONST ? model.value.constant.value : null;

	return <FieldInlineLabel>{value || "Not supported"}</FieldInlineLabel>;
};

export const ControlStringTranslate = (model: TGenericModelNode): IInspectorControls => ({
	primary: {
		component: ControlStringTranslate_Primary,
		model: model
	}
});
